export default __webpack_public_path__ + "static/media/phone@2x.dedd873c.png";